var render, staticRenderFns
import script from "./ListboxItem.vue?vue&type=script&lang=js&"
export * from "./ListboxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListboxItem.vue"
export default component.exports